import {BackSide, BufferGeometry, type Side} from 'three'
import {RenderEventDispatcher} from '../event-dispatcher'

type RenderableObjectParserEvent = {
  type: 'error:fatal' | 'load'
  load: {
    data?: string
    content?: BufferGeometry
  }
  'error:fatal': {
    data?: string
    message?: string
  }
}
export abstract class RenderableObjectParser extends RenderEventDispatcher<RenderableObjectParserEvent> {
  side(): Side {
    return BackSide
  }

  announce(geometry: BufferGeometry) {
    if (geometry) {
      this.dispatchEvent({
        type: 'load',
        content: geometry,
      })
    } else {
      this.dispatchEvent({
        type: 'error:fatal',
        message: 'Model not valid.',
      })
    }
  }

  abstract parse(data: string): void
}
